import { mergeProps, createVNode } from "vue";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Wrap of sub component which need use as Button capacity (like Icon component).
 * This helps accessibility reader to tread as a interactive button to operation.
 */
import KeyCode from './KeyCode';
import PropTypes from './vue-types';
var inlineStyle = {
  border: 0,
  background: 'transparent',
  padding: 0,
  lineHeight: 'inherit',
  display: 'inline-block'
};
var TransButton = {
  name: 'TransButton',
  inheritAttrs: false,
  props: {
    noStyle: PropTypes.bool,
    onClick: PropTypes.func
  },
  methods: {
    onKeyDown: function onKeyDown(event) {
      var keyCode = event.keyCode;

      if (keyCode === KeyCode.ENTER) {
        event.preventDefault();
      }
    },
    onKeyUp: function onKeyUp(event) {
      var keyCode = event.keyCode;

      if (keyCode === KeyCode.ENTER) {
        this.$emit('click', event);
      }
    },
    setRef: function setRef(btn) {
      this.$refs.div = btn;
    },
    focus: function focus() {
      if (this.$refs.div) {
        this.$refs.div.focus();
      }
    },
    blur: function blur() {
      if (this.$refs.div) {
        this.$refs.div.blur();
      }
    }
  },
  render: function render() {
    var _this$$props = this.$props,
        noStyle = _this$$props.noStyle,
        onClick = _this$$props.onClick;
    return createVNode("div", mergeProps({
      "role": "button",
      "tabindex": 0,
      "ref": "div"
    }, this.$attrs, {
      "onClick": onClick,
      "onKeydown": this.onKeyDown,
      "onKeyup": this.onKeyUp,
      "style": _objectSpread({}, !noStyle ? inlineStyle : null)
    }), [this.$slots.default && this.$slots.default()]);
  }
};
export default TransButton;